import dayjs from "dayjs";

export const capitalizeFirstLetter = (string) =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const formatDateMessage = (dateTime, selectedOption, streamerName) => {
  const today = dayjs().startOf("day");
  const tomorrow = dayjs().add(1, "day").startOf("day");
  const dateOnly = dateTime.startOf("day");

  let dayText = "";

  if (dateOnly.isSame(today)) {
    dayText = "Hoy";
  } else if (dateOnly.isSame(tomorrow)) {
    dayText = "Mañana";
  } else if (dateOnly.isBefore(today.add(7, "day"))) {
    const dayOfWeek = dateTime.locale("es").format("dddd");
    dayText = `El ${capitalizeFirstLetter(dayOfWeek)}`;
  } else {
    const dayOfWeek = dateTime.locale("es").format("dddd");
    const dateStr = dateTime.locale("es").format("DD/MMM");
    dayText = `El ${capitalizeFirstLetter(dayOfWeek)} ${dateStr}`;
  }

  const timeStr = dateTime.format("HH:mm");
  const modeText = selectedOption === "directo" ? "en directo" : "en diferido";

  return `${dayText} a las ${timeStr} ${modeText} en el canal de ${streamerName}`;
};
